<div class="face-id-span"><i class="icon ico-face-id" [ngClass]="{'auth-success ico-success': isAuthSuccess}"></i></div>
